import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const actionHeaderDefaultVariants = {
  "sticky": false,
  "skeleton": false
}
const actionHeaderCompoundVariants = []

const actionHeaderSlotNames = [
  [
    "root",
    "action-header__root"
  ],
  [
    "title",
    "action-header__title"
  ],
  [
    "actions",
    "action-header__actions"
  ]
]
const actionHeaderSlotFns = /* @__PURE__ */ actionHeaderSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, actionHeaderDefaultVariants, getSlotCompoundVariant(actionHeaderCompoundVariants, slotName))])

const actionHeaderFn = memo((props = {}) => {
  return Object.fromEntries(actionHeaderSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const actionHeaderVariantKeys = [
  "sticky",
  "skeleton"
]
const getVariantProps = (variants) => ({ ...actionHeaderDefaultVariants, ...compact(variants) })

export const actionHeader = /* @__PURE__ */ Object.assign(actionHeaderFn, {
  __recipe__: false,
  __name__: 'actionHeader',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: actionHeaderVariantKeys,
  variantMap: {
  "sticky": [
    "true",
    "false"
  ],
  "skeleton": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, actionHeaderVariantKeys)
  },
  getVariantProps
})